<template>
    <div class="form-data">
        <radio-input v-model="form.category" :data="inputs.category" />
        <div v-if='form.category == "exact_sciences" || form.category == "natural_sciences"'>
            <div class="d-flex justify-content-center">
                <div class="col-sm-9">
                    <p class="text-18 form__title form__pb-8 form__pt-24">Wybierz przedmiot<span
                            class="form__label form__label--red">*</span></p>
                    <vue-select :close-on-select="true" v-model="form.school_subject" placeholder="Wybierz przedmiot"
                        :options="get_category_options" label-by="name" value-by="value">
                        <template #label="{ selected }">
                            <template v-if="selected">
                                <div>{{ selected.name }}</div>
                            </template>
                        </template>
                    </vue-select>
                </div>
            </div>
            <div class="text-danger text-center" v-if="schoolSubjectError">
                {{ schoolSubjectError }}
            </div>
        </div>
        <div v-if="get_type && form.category">
            <div class="heading-24 form__title text-center -pt-4">
                Średnia ocen
            </div>
            <div class="d-flex justify-content-center">
                <div class="col-sm-9">
                    <p class="text-18 form__title form__pb-8 form__pt-24">Wybierz średnią ocen<span
                            class="form__label form__label--red">*</span></p>
                    <vue-select :close-on-select="true" v-model="form.average" placeholder="Wybierz średnią ocen"
                        :options="inputs.average.options[get_type][form.category]" label-by="name" value-by="value">
                        <template #label="{ selected }">
                            <template v-if="selected">
                                <div>{{ selected.name }}</div>
                            </template>
                        </template>
                    </vue-select>
                </div>
            </div>
            <div class="text-danger text-center" v-if="averageError">
                {{ averageError }}
            </div>
        </div>
        <radio-input v-model="form.behavior" :data="inputs.behavior" />
    </div>
</template>

<script>
import RadioInput from "@/components/inputs/RadioInput.vue";
import VueNextSelect from 'vue-next-select';


export default {
    emits: ['update:modelValue', 'type'],
    props: ['errors', 'modelValue'],
    data() {
        return {
            inputs: {
                category: {
                    type: 'radio',
                    title: 'Kategoria talentu',
                    subtitle: null,
                    mandatory: '*',
                    options: [
                        {
                            name: 'Nauki ścisłe',
                            value: 'exact_sciences',
                            options: [
                                {
                                    name: 'Matematyka',
                                    value: 'math'
                                },
                                {
                                    name: 'Informatyka',
                                    value: 'informatics'
                                },
                                {
                                    name: 'Telekomunikacja',
                                    value: 'telecommunication'
                                },
                                {
                                    name: 'Elektronika i elektrotechnika',
                                    value: 'electronics'
                                },
                            ]
                        },
                        {
                            name: 'Nauki przyrodnicze',
                            value: 'natural_sciences',
                            options: [
                                {
                                    name: 'Astronomia',
                                    value: 'astronomy'
                                },
                                {
                                    name: 'Nauki biologiczne',
                                    value: 'biology'
                                },
                                {
                                    name: 'Nauki fizyczne',
                                    value: 'physics'
                                },
                                {
                                    name: 'Nauki chemiczne',
                                    value: 'chemistry'
                                },
                                {
                                    name: 'Nauki o Ziemi i środowiksu np. geografia, geologia',
                                    value: 'geography'
                                },
                            ]
                        },
                        {
                            name: 'Zaangażowanie społeczne',
                            small: '(wolontariat)',
                            value: 'social'
                        }
                    ],
                    model: 'category',
                    stage: 'formStudent.student.category'
                },
                average: {
                    options: {
                        primary_school: {
                            exact_sciences: [
                                {
                                    name: '>5,3',
                                    value: 5
                                },
                                {
                                    name: '5,00 - 5,30',
                                    value: 4
                                },
                                {
                                    name: '4,81 - 4,99',
                                    value: 3
                                },
                                {
                                    name: '4,61 - 4,80',
                                    value: 2
                                },
                                {
                                    name: '4,50 - 4,60',
                                    value: 1
                                },
                            ],
                            natural_sciences: [
                                {
                                    name: '>5,3',
                                    value: 5
                                },
                                {
                                    name: '5,00 - 5,30',
                                    value: 4
                                },
                                {
                                    name: '4,81 - 4,99',
                                    value: 3
                                },
                                {
                                    name: '4,61 - 4,80',
                                    value: 2
                                },
                                {
                                    name: '4,50 - 4,60',
                                    value: 1
                                },
                            ],
                            social: [
                                {
                                    name: '>5,2',
                                    value: 5
                                },
                                {
                                    name: '5,00 - 5,2',
                                    value: 4
                                },
                                {
                                    name: '4,61 - 4,99',
                                    value: 3
                                },
                                {
                                    name: '4,31 - 4,60',
                                    value: 2
                                },
                                {
                                    name: '4,00 - 4,30',
                                    value: 1
                                },
                            ]

                        },
                        secondary_school: {
                            exact_sciences: [
                                {
                                    name: '>5,2',
                                    value: 5
                                },
                                {
                                    name: '5,00 - 5,20',
                                    value: 4
                                },
                                {
                                    name: '4,81 - 4,99',
                                    value: 3
                                },
                                {
                                    name: '4,51 - 4,80',
                                    value: 2
                                },
                                {
                                    name: '4,25 - 4,50',
                                    value: 1
                                },
                            ],
                            natural_sciences: [
                                {
                                    name: '>5,2',
                                    value: 5
                                },
                                {
                                    name: '5,00 - 5,00',
                                    value: 4
                                },
                                {
                                    name: '4,81 - 4,99',
                                    value: 3
                                },
                                {
                                    name: '4,51 - 4,80',
                                    value: 2
                                },
                                {
                                    name: '4,25 - 4,50',
                                    value: 1
                                },
                            ],
                            social: [
                                {
                                    name: '>5,1',
                                    value: 5
                                },
                                {
                                    name: '5,00 - 5,10',
                                    value: 4
                                },
                                {
                                    name: '4,61 - 4,99',
                                    value: 3
                                },
                                {
                                    name: '4,31 - 4,60',
                                    value: 2
                                },
                                {
                                    name: '4,00 - 4,30',
                                    value: 1
                                },
                            ]
                        },
                    }
                    ,

                    model: 'average',
                    stage: 'formStudent.student.average'
                },
                behavior: {
                    type: 'radio',
                    title: 'Ocena z zachowania',
                    subtitle: 'w roku szkolnym 2025/2026',
                    mandatory: '*',
                    options: [
                        {
                            name: 'wzorowe',
                            value: 'wzorowe'
                        },
                        {
                            name: 'bardzo dobre',
                            value: 'bardzo dobre'
                        },
                        {
                            name: 'dobre',
                            value: 'dobre'
                        }
                    ],
                    stage: 'formStudent.student.behavior'
                },
            },
            form: {
                category: null,
                average: null,
                behavior: null,
                school_subject: null,
            }
        }
    },
    components: {
        RadioInput,
        'vue-select': VueNextSelect,
    },
    computed: {
        get_type() {
            return this.$store.getters.getValuByPath('formStudent.application.type');
        },
        averageError() {
            const error = this.$store.getters.getError('student.average')
            return error ? error[0] : null;
        },
        schoolSubjectError() {
            const error = this.$store.getters.getError('student.school_subject')
            return error ? error[0] : null;
        },
        get_category_options() {
            return this.inputs.category.options.find(option => option.value === this.form.category).options;
        }
    },
    watch: {
        form: {
            handler(newValue) {
                this.$emit('update:modelValue', newValue)
            },
            deep: true
        },
        'form.category'() {
            this.form.school_subject = null;
            this.updateFormValue('formStudent.student.school_subject', null);
            this.$store.commit('removeError', 'formStudent.student.school_subject')
        },
        'form.average'(newVal) {
            this.updateFormValue('formStudent.student.average', newVal);
            this.$store.commit('removeError', 'formStudent.student.average')
        },
        'form.school_subject'(newVal) {
            this.updateFormValue('formStudent.student.school_subject', newVal);
            this.$store.commit('removeError', 'formStudent.student.school_subject')
        },
    },
    methods: {
    },
};
</script>
